/** Preserve bookmarked feature links, including the selected pipeline node and document. */
export function getCaptureLocation(location: { pathname: string; search: string; hash: string }) {
  return {
    pathname: location.pathname
      .replace(/^\/(?:dispatch|capture)(?=\/|$)/, '/connect')
      .replace(/^\/documentation\/(?:dispatch|capture)-faqs(?=\/|$)/, '/documentation/connect-faqs'),
    search: location.search,
    hash: location.hash
  };
}
